module.exports = __webpack_public_path__ + "img/flexible-character.1aebfe5b.svg";